import { SingleSubType, BetSlipType } from './types';

// 依据code 生成唯一的key
export const generateUniqueKey = (oddsData: Record<string, any>[]) => {
  return oddsData
    .map((s) => s.code)
    .sort()
    .join('_');
};

// 不四舍五入截取小数位数
export const truncateDecimal = (value: number, decimals = 0) => {
  const factor = Math.pow(10, decimals);
  return Math.trunc(value * factor) / factor;
};

// 获取不同的比赛ID
export const getUniqueMatchIdCount = (arr: any[]) => {
  return new Set(
    arr.filter((o) => o.type !== SingleSubType.CustomBet && o.type !== SingleSubType.Outright).map((o) => o.matchId)
  ).size;
};

export const isEmpty = <T extends object>(obj: T | (() => T)): boolean => {
  const value = typeof obj === 'function' ? (obj as any)() : obj;
  return value != null && Object.keys(value).length === 0 && value.constructor === Object;
};

// betslip 依据数据tab自动切换
export const autoToggleBetType = (oddsData: Record<string, any>[], type: BetSlipType): BetSlipType => {
  const betType =
    (type === BetSlipType.Combo && oddsData.length < 2 && BetSlipType.Single) ||
    (type === BetSlipType.System && getUniqueMatchIdCount(oddsData) < 3 && BetSlipType.Combo) ||
    type;

  return betType;
};

// 针对购物车数据存储 方法封装
const BETSLIP_STORAGE_KEY = 'bz_betslip_data';
const EXPIRE_TIME = 24 * 60 * 60 * 1000; // 24小时

export const betslipStorage = {
  set(data: Record<string, any>[]) {
    const payload = {
      timestamp: Date.now(),
      data,
    };
    localStorage.setItem(BETSLIP_STORAGE_KEY, JSON.stringify(payload));
  },

  get() {
    const dataStr = localStorage.getItem(BETSLIP_STORAGE_KEY);
    if (!dataStr) return [];

    try {
      const { timestamp, data } = JSON.parse(dataStr);
      if (Date.now() - timestamp > EXPIRE_TIME) {
        localStorage.removeItem(BETSLIP_STORAGE_KEY);
        return [];
      }
      return data;
    } catch {
      return [];
    }
  },
};
